import React, { useMemo } from "react";
import PropTypes from "prop-types";
import { currencyFormatter } from "@sia/style-guide";
import "./PreviousSurveyAccordionFIBU.scss";

const hasAmount = (value) => value !== null && value !== undefined && value !== "" && Number.isFinite(Number(value));
const rowTotal = (item) => (item.content || []).reduce((total, row) => total + (hasAmount(row.amount) ? Number(row.amount) : 0), 0);
const formatAmount = (value) => (hasAmount(value) ? currencyFormatter.formatAlternate(Number(value), "CHF") : "—");

const PreviousSurveyAccordionFIBU = ({ items, grandTotalText }) => {
  const visibleItems = useMemo(() => items.filter((item) => String(item.id) !== "61"), [items]);
  const salesItem = useMemo(() => items.find((item) => String(item.id) === "61") || null, [items]);

  const grandTotal = visibleItems.reduce((total, item) => total + rowTotal(item), 0);

  return (
    <div className="fibu" data-testid="previous-survey-overheads">
      <ul className="fibu__items">
        {visibleItems.map((item) => {
          return (
            <>
              <button type="button" className="fibu__heading">
                <span>{item.title}</span>
                <span className="fibu__heading-total">{formatAmount(rowTotal(item))}</span>
              </button>
              <div className="fibu__content">
                {(item.content || []).map((row) => (
                  <div key={row.id} className="fibu__row">
                    <span>{row.label}</span>
                    <span className="fibu__amount">{formatAmount(row.amount)}</span>
                  </div>
                ))}
              </div>
            </>
          );
        })}
      </ul>

      <div className="fibu__grand-total">
        <span>{grandTotalText}</span>
        <span>{formatAmount(grandTotal)}</span>
      </div>

      {salesItem && (
        <div className="fibu__sales">
          <span>{salesItem.title}</span>
          <span className="fibu__amount">{formatAmount(salesItem.content?.[0]?.amount ?? salesItem.total)}</span>
        </div>
      )}
    </div>
  );
};

PreviousSurveyAccordionFIBU.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
      title: PropTypes.string,
      tooltip: PropTypes.string,
      total: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      content: PropTypes.array,
    })
  ),
  grandTotalText: PropTypes.string.isRequired,
};

PreviousSurveyAccordionFIBU.defaultProps = { items: [] };

export default PreviousSurveyAccordionFIBU;
